import { APIResponse, OrderCarDocuments } from "@/shared/api-contract/api-contract";
import { useI18n } from "@/shared/composables/use-i18n";
import { pageLoaderModel } from "@/shared/models/page-loader";
import format from "date-fns/format";
import { setup } from "vue-class-component";
import { Model, Prop, Vue } from "vue-property-decorator";
import { appAxios } from "@/core/utils/appAxios";
import env from "@/shared/models/environment";

export class DocumentsPopup extends Vue {
    i18n = setup(useI18n);
    pageLoader = pageLoaderModel;

    @Model("_show", { required: true })
    show!: boolean;
    @Prop({ required: true })
    orderId?: number;
    @Prop({ required: true })
    carId?: number;

    orderCarDocuments: OrderCarDocuments = {} as OrderCarDocuments;

    async mounted() {
        const res = await appAxios.value.get<APIResponse<OrderCarDocuments>>(
            `${env.FILE_MAKER_API}web/orders/${this.orderId}/${this.carId}/documents`,
        );
        if (res?.data?.data) this.orderCarDocuments = res.data.data;
    }

    formatDate(dateToFormat?: number): string {
        if (!dateToFormat) return "";
        return format(new Date(dateToFormat), "dd/MM/yyyy hh:mm");
    }
}
